import { isAxiosApiError } from "@base/lib/utils";
import { isAxiosError } from "axios";
import { DAILY_LOG_SEARCH_ERROR_CODE } from "./dailyLogSearchSchema";

/**
 * 검색 실패를 화면 동작 단위로 분류한다. 서버 message는 사용자 문구로 쓰지 않는다.
 * 정본: docs/bricks-milestone-2/api-contract.md §5
 */
export type DailyLogSearchErrorKind =
  | "invalid-request"
  | "cursor-invalid"
  | "cursor-expired"
  | "forbidden"
  | "unauthorized"
  | "rate-limited"
  | "not-ready"
  | "network"
  | "canceled"
  | "server";

export function getDailyLogSearchErrorKind(error: unknown): DailyLogSearchErrorKind {
  if (!isAxiosError(error)) return "server";
  if (error.code === "ERR_CANCELED") return "canceled";
  if (!error.response) return "network";

  const code = isAxiosApiError(error) ? error.response.data.code : undefined;
  if (code === DAILY_LOG_SEARCH_ERROR_CODE.CURSOR_EXPIRED) return "cursor-expired";
  if (code === DAILY_LOG_SEARCH_ERROR_CODE.CURSOR_INVALID) return "cursor-invalid";
  if (code === DAILY_LOG_SEARCH_ERROR_CODE.NOT_READY) return "not-ready";

  const { status } = error.response;
  if (status === 400) return "invalid-request";
  if (status === 401) return "unauthorized";
  if (status === 403) return "forbidden";
  if (status === 429) return "rate-limited";
  return "server";
}

/** 같은 cursor로 다시 요청해도 결과가 바뀌지 않는 오류. 새 체인(Refresh)으로만 복구한다 */
export function isCursorErrorKind(kind: DailyLogSearchErrorKind): boolean {
  return kind === "cursor-expired" || kind === "cursor-invalid";
}

/** 보호 데이터를 더 보여 주면 안 되는 오류 */
export function isAccessErrorKind(kind: DailyLogSearchErrorKind): boolean {
  return kind === "forbidden" || kind === "unauthorized";
}
